import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Alert, Snackbar } from '@mui/material';
import { getApiUrl } from '../config';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function About() {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: ''
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    fetch(getApiUrl('/api/info/about'), {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
    })
    .then(res => res.json())
    .then(data => {
      if (data && typeof data === 'object') {
        setFormData(prev => ({ ...prev, ...data }));
      }
    })
    .catch(error => {
      console.error('Error fetching about info:', error);
      setSnackbar({ open: true, message: 'خطا در دریافت اطلاعات درباره ما', severity: 'error' });
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const res = await fetch(getApiUrl('/api/info/about'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        setSnackbar({ open: true, message: 'اطلاعات درباره ما با موفقیت ذخیره شد', severity: 'success' });
      } else {
        setSnackbar({ open: true, message: 'خطا در ذخیره اطلاعات درباره ما', severity: 'error' });
      }
    } catch (error) {
      console.error('Error saving about info:', error);
      setSnackbar({ open: true, message: 'خطا در ذخیره اطلاعات درباره ما', severity: 'error' });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom style={{fontFamily: 'Vazir'}}>
        اطلاعات درباره ما
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 800 }}>
        <TextField
          fullWidth
          label="عنوان"
          name="title"
          value={formData.title}
          onChange={handleChange}
          margin="normal"
          required
        />

        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            محتوا *
          </Typography>
          <ReactQuill
            value={formData.content}
            onChange={(value) => setFormData({ ...formData, content: value })}
            theme="snow"
            style={{ height: '300px', marginBottom: '50px' }}
            modules={{
              toolbar: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
                ['link', 'image'],
                ['clean']
              ]
            }}
          />
        </Box>

        <TextField
          fullWidth
          label="عنوان SEO"
          name="meta_title"
          value={formData.meta_title}
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          label="توضیحات SEO"
          name="meta_description"
          value={formData.meta_description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
        />

        <TextField
          fullWidth
          label="کلمات کلیدی SEO"
          name="meta_keywords"
          value={formData.meta_keywords}
          onChange={handleChange}
          margin="normal"
        />

        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3 }}
        >
          ذخیره اطلاعات
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default About; 